import React from 'react';

// The Devices QC'd / Passed / Failed / Pass rate tile row, shared by the QC
// import summary and the expanded delivery row in the Goods-in QC index, so the
// same four numbers are always presented the same way.
//
// `surface` picks the fill: 'inset' for tiles on a white card (the import
// summary), 'raised' for tiles sitting on an already-inset panel (the expanded
// delivery row), where an inset fill would vanish into the background.
//
// `tiles` is [{ label, value, color }].
export default function QcStatTiles({ tiles = [], surface = 'inset' }) {
  const bg = surface === 'raised' ? 'var(--surface-default)' : 'var(--surface-inset)';
  return (
    <div style={{ display: 'flex', gap: 'var(--space-2)', flexWrap: 'wrap' }}>
      {tiles.filter(Boolean).map(t => (
        <div key={t.label} style={{
          flex: 1, minWidth: 96, padding: '10px 12px',
          borderRadius: 'var(--radius-lg)', background: bg,
          border: '1px solid var(--border-subtle)',
        }}>
          <div style={{
            fontSize: 10, fontWeight: 700, textTransform: 'uppercase',
            letterSpacing: '0.04em', color: 'var(--text-muted)', marginBottom: 3,
          }}>{t.label}</div>
          <div className="tnum" style={{ fontSize: 20, fontWeight: 700, color: t.color || 'var(--text-default)' }}>
            {t.value}
          </div>
        </div>
      ))}
    </div>
  );
}
